import type { ProfileProps } from '@/repositories/auth/AuthRepository.types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/libs/axios/apiClient';
import { apiConfig } from '@/config/api';

export const useUpdateAccount = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateAccount,
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ['customer', 'account'] }),
  });
};

const updateAccount = async (props: UpdateAccountParams) => {
  const { data } = await api.put<Omit<ProfileProps, 'subscription'>>(
    apiConfig.routes.auth.account,
    props
  );
  return data;
};

type UpdateAccountParams = {
  document?: string;
  name?: string;
  password?: string;
};
